import React, { useContext } from 'react'
import { LeaderRow } from './TeamLeaderCard/leaderStyles'
import { TeamContext } from '../../Context/TeamContext/TeamContext'
import { LeaderCard } from './TeamLeaderCard/LeaderCard'
import { champSeriesStatTitles, statTitles } from '../../Constants/player'

export const TeamLeadersContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { csStarted  } = useContext(TeamContext)!
  let titlesToUse = csStarted ? champSeriesStatTitles : statTitles
  return (
    <>
      <LeaderRow>
        {titlesToUse.map((stat, index: number) => (
          <LeaderCard key={index} stat={stat} />
        ))}
      </LeaderRow>
    </>
  )
}
